/*
 * Fonctions utiles pour les conditions des filtres
 */
export function estEgale(valeurCondition: any): (valeurVariable: any) => (boolean) {
    return function (valeurVariable): boolean {
        return valeurVariable === valeurCondition;
    };
}
export function estSuperieur(valeurCondition: any): (valeurVariable: any) => (boolean) {
    return function (valeurVariable): boolean {
        return valeurVariable > valeurCondition;
    };
}
export function estInferieur(valeurCondition: any): (valeurVariable: any) => (boolean) {
    return function (valeurVariable): boolean {
        return valeurVariable < valeurCondition;
    };
}
export function estSuperieurEgal(valeurCondition: any): (valeurVariable: any) => (boolean) {
    return function (valeurVariable): boolean {
        return valeurVariable >= valeurCondition;
    };
}
export function estInferieurEgal(valeurCondition: any): (valeurVariable: any) => (boolean) {
    return function (valeurVariable): boolean {
        return valeurVariable <= valeurCondition;
    };
}
/**
 * Permet de savoir si la valeur est comprise dans les valeurs du tableau passé en argument
 * @param valeurCondition Un tableau contenant les différentes valeurs possibles
 */
export function estDans(valeurCondition: any[]): (valeurVariable: any) => (boolean) {
  return function (valeurVariable): boolean {
    const result = valeurCondition.findIndex((valeur) => valeur === valeurVariable);
    return result > -1;
  };
}
